import React, { useState, useEffect, Fragment } from 'react';
import {
  Popconfirm, Select, Table,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import { connect } from 'react-redux';
import SellerActions from '@Actions/sellerActions';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import quickUpdateActions from '../../../../actions/quickUpdate/quickUpdateActions';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;

const UpdateTallyVendors = ({
  getTallySellers, tallySellers, user, getTallySellersLoading, data, callback, quickUpdateEntityWise,
}) => {
  const [sellerMapping, setSellerMapping] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedSellerTally, setSelectedSellerTally] = useState();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    getTallySellers(user?.tenant_info?.it_id, user.org_id, '', '', data?.[0]?.tally_sellers?.[0]?.temp_tally_seller_id);
  }, []);

  useEffect(() => {
    if (data?.length) {
      const initialMappings = data?.map((seller) => ({
        sellerId: seller?.seller_info?.seller_id,
        tallySellerName: seller?.tally_sellers?.[0]?.seller_name || '',
        prev_temp_tally_seller_id: seller?.tally_sellers?.[0]?.temp_tally_seller_id,
      }));
      setSellerMapping(initialMappings);
      setSelectedSellerTally(data?.[0]?.tally_sellers?.[0]?.temp_tally_seller_id || '');
    }
  }, []);

  useEffect(() => {
    if (searchKeyword) {
      const delayDebounceFn = setTimeout(() => {
        getTallySellers(user?.tenant_info?.it_id, user?.org_id, searchKeyword);
      }, 1300);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchKeyword]);

  const handleSearch = (val) => {
    setSearchKeyword(val);
    setOpen(true);
  };

  const handleChange = (val, record) => {
    const tempSelectedSeller = tallySellers?.data?.find((item) => item.temp_tally_seller_id === val);
    setSellerMapping((prevMappings) => {
      const sellerIndex = prevMappings.findIndex((product) => product.sellerId === record.seller_id);
      const updatedMappings = [...prevMappings];
      updatedMappings[sellerIndex] = {
        ...updatedMappings[sellerIndex],
        tallySellerName: tempSelectedSeller?.seller_name,
        temp_tally_seller_id: tempSelectedSeller?.temp_tally_seller_id,
      };
      return updatedMappings;
    });
    setSelectedSellerTally(tempSelectedSeller?.temp_tally_seller_id || '');
    setOpen(false);
  };

  const ledgerMappingColumns = () => [
    {
      title: 'Name On Procuzy',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      fixed: 'left',
      width: '250px',
      render: (text, record) => (
        <Fragment>
          <H3Text text={`${record?.alias_name}`} />
        </Fragment>
      ),
    },
    {
      title: 'Name On Tally',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '300px',
      render: (text, record) => (
        <Fragment>
          <PRZSelect
            value={selectedSellerTally}
            showSearch
            filterOption={false}
            onSearch={handleSearch}
            searchValue={searchKeyword}
            open={open}
            onChange={(val) => handleChange(val, record)}
            onDropdownVisibleChange={(isOpen) => setOpen(isOpen)}
            size="small"
            allowClear
            style={{
              width: '300px',
            }}
            disabled={getTallySellersLoading}
          >
            {tallySellers?.data?.map((item) => (
              <Option key={item.temp_tally_seller_id} value={item.temp_tally_seller_id}>
                {item.seller_name}
              </Option>
            ))}
          </PRZSelect>
        </Fragment>
      ),
    },
    {
      title: '',
      fixed: 'right',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <Popconfirm
          title={(
            <React.Fragment>
              Unlinking the vendor will result in the creation of a new ledger/master in Tally.
              <br />
              To avoid duplication, please proceed with caution.
            </React.Fragment>
          )}
          placement="bottomRight"
          onConfirm={() => {
            setLoading(true);
            const payload = {
              sellerMapping: [{
                sellerId: record?.seller_id,
                tallySellerName: '',
                prev_temp_tally_seller_id: record?.tally_sellers?.[0]?.temp_tally_seller_id,
              }],
              org_id: user?.tenant_info?.org_id,
              entity_name: 'SELLER',
            };
            quickUpdateEntityWise(payload, () => {
              setLoading(false);
              callback();
            });
          }}

        >
          <div style={{
            marginLeft: 'auto',
            textDecoration: 'underline',
            color: 'rgb(45, 124, 247)',
          }}
          >
            <H3Text
              text="Unlink"
              className="table-subscript"
            />
          </div>
        </Popconfirm>
      ),
    },
  ];
  const handleUpdate = () => {
    setLoading(true);
    const payload = {
      sellerMapping,
      org_id: user?.tenant_info?.org_id,
      entity_name: 'SELLER',
    };
    if (!sellerMapping?.[0]?.temp_tally_seller_id) {
      // notification.error({
      //   message: 'Please select vendor to update',
      //   placement: 'top',
      //   duration: 3,
      // });
      setLoading(false);
      return;
    }
    quickUpdateEntityWise(payload, () => {
      setLoading(false);
      callback();
    });
  };
  return (
    <React.Fragment>
      <Table
        showHeader
        size="small"
        columns={ledgerMappingColumns()}
        bordered
        dataSource={data || []}
        pagination={false}
      />
      <div className="custom-drawer__footer flex-display" style={{ width: '100%' }}>
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text="Update"
          onClick={handleUpdate}
          style={{
            borderRadius: '5px',
            padding: '9px 15px',
            width: '100px',
          }}
          isLoading={getTallySellersLoading || loading}
          disabled={getTallySellersLoading || loading}
        />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ UserReducers, SellerReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  tallySellers: SellerReducers.tallySellers,
  getTallySellersLoading: SellerReducers?.getTallySellersLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getTallySellers: (itId, orgId, searchKeyword, callback, selectedSeller) => dispatch(SellerActions.getTallySellers(itId, orgId, searchKeyword, callback, selectedSeller)),
  quickUpdateEntityWise: (payload, Callback, rollback) => dispatch(quickUpdateActions.quickUpdateEntityWise(payload, Callback, rollback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTallyVendors);
